// extracted by mini-css-extract-plugin
export default {"greenBadge":"sms_greenBadge__SOxbe","infoBadge":"sms_infoBadge__Wenhf","dangerBadge":"sms_dangerBadge__Rtbsz"};